import type { Theme } from 'ht-sdk/react';
import { Check, KeyRoundIcon, Loader, LogIn, LogOut, Menu, ShieldCheck, ShieldOff, User } from 'lucide-react';

export const theme: Theme = {
	icons: {
		loader: Loader,
		user: User,
		menu: Menu,
		login: LogIn,
		logout: LogOut,
		twoFaEnabled: ShieldCheck,
		twoFaDisabled: ShieldOff,
		success: Check,
		passkeyEnabled: KeyRoundIcon,
		passkeyDisabled: KeyRoundIcon,
	},
};
